"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BOTTOM = exports.MIDDLE = exports.TOP = void 0;
// (C) 2019-2021 GoodData Corporation
/**
 * @internal
 */
exports.TOP = "top";
/**
 * @internal
 */
exports.MIDDLE = "middle";
/**
 * @internal
 */
exports.BOTTOM = "bottom";
//# sourceMappingURL=alignments.js.map